const STORAGE_KEY = "gvt-chat-live-thinking-details-open";

/** Whether live answers should show the step-by-step thinking log while streaming. */
export function readLiveThinkingDetailsOpen(): boolean {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored === "false") {
			return false;
		}
		if (stored === "true") {
			return true;
		}
	} catch {
		// localStorage unavailable (SSR, privacy mode).
	}
	return false;
}

export function writeLiveThinkingDetailsOpen(open: boolean): void {
	try {
		localStorage.setItem(STORAGE_KEY, open ? "true" : "false");
	} catch {
		// ignore
	}
}
